<script setup lang="ts">import { computed as _computed } from 'vue';

import type { CategoriesList } from "./models";

interface Props {
  model: CategoriesList;
  hasShearForce: boolean;
  hasVariants: boolean;
}

const props = defineProps<Props>();

const fixedHeaderHeight = _computed(() =>
  64 + (props.hasShearForce ? 33 : 0) + (props.hasVariants ? 33 : 0) + "px");
</script>

<template>
  <table class="categories-table__fixed">
    <thead>
      <tr :style="{ height: fixedHeaderHeight }">
        <th class="categories-table__group">Height</th>
        <th class="categories-table__group">Fire<br/>protection</th>
        <th class="categories-table__group">Wall type</th>
      </tr>
    </thead>
    <tbody>
      <template
        v-for="(heightCollection, height) in model"
        :key="height"
      >
        <template
          v-for="(fpCollection, fp) in heightCollection"
          :key="fp"
        >
          <tr
            v-for="(_, wallStructure) in fpCollection"
            class="categories-table__group"
            :key="wallStructure"
          >
            <th
              v-if="
                fp === Object.keys(heightCollection)[0] &&
                wallStructure === Object.keys(fpCollection)[0]
              "
              :rowspan="Object.keys(heightCollection).length * 3"
            >
              {{ height }}
            </th>
              <th
              v-if="wallStructure === Object.keys(fpCollection)[0]"
              rowspan="3"
              >
              {{ Object.keys(heightCollection).includes('R90') && fp === 'REI120' ? 'REI120 / R90' : fp }}
            </th>
            <th>{{ wallStructure }}</th>
          </tr>
        </template>
      </template>
    </tbody>
  </table>
</template>

<style lang="scss">
  .categories-table__fixed {
    height: min-content;

    th {
      text-align: left;
    }
  }
</style>
